import {userRegister,userLogin,getUserInfo} from '../../api/user'
import { getNotificationCount } from '../../api/notification'
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    userAccount: '',
    userName: '',
    userImg: require('../../assets/default/avatar.jpg'),
    fbLoginStatus:'',
    fbToken:'',
    accessToken:'',
    userEmail:'',
    ownExchangeItemList: [],
    followingItemList: [],
    showLoginPopup: false,
    showAddExchange: false,
    showAddTogether: false,
    showUserInfo:false,
    notificationCount: 0
})

  // getters
const getters = {
  //   cartProducts: (state, getters, rootState) => {
  //     return state.items.map(({ id, quantity }) => {
  //       const product = rootState.products.all.find(product => product.id === id)
  //       return {
  //         title: product.title,
  //         price: product.price,
  //         quantity
  //       }
  //     })
  //   },
  
  //   cartTotalPrice: (state, getters) => {
  //     return getters.cartProducts.reduce((total, product) => {
  //       return total + product.price * product.quantity
  //     }, 0)
  //   }
  }
  
  // actions
  const actions = {
    userRegister({commit},params){
        return new Promise((resolve, reject) => {
            userRegister(params).then(res=>{
                if (res.status === 'success'){
                    commit('setUserEmail',res.body.email)
                    commit('setuserName',res.body.userName)
                    resolve()
                }
            })
        });
    },
    userLogin({commit},params){
        return new Promise((resolve, reject) => {
            userLogin(params).then(res=>{
                console.log(res)
                if (res.status === 'success'){
                    commit('setUserEmail',res.body.email)
                    commit('setuserName',res.body.userName)
                    commit('setAccessToken',res.body.access_token)
                    resolve()
                }
            })
        });
    },
    // todo
    getUserInfo({commit},params){
        return new Promise((resolve, reject) => {
            getUserInfo(params).then(res=>{
                console.log(res)
                if (res.status === 'success'){
                    commit('setUserEmail',res.body.email)
                    commit('setuserName',res.body.userName)
                    commit('setAccessToken',res.body.access_token)
                    resolve()
                }
            })
        });
    },
    checkFbStatus({commit,dispatch,state}){
        FB.getLoginStatus(function(res) {
            commit('setFbToken',res.status)
            if (res.status === 'connected') {
                // Logged into your app and Facebook.
                commit('setFbToken','isLogin')
                commit('setFbToken',res.accessToken)
                dispatch('getFbInfo')
              } 
        });
      },
      fbLogin({commit,dispatch}){
        FB.login(function(res){
            commit('setFbToken',res.accessToken)
            dispatch('getFbInfo')
          },{scope: 'public_profile,email'});
      },
      getFbInfo({commit}){
        FB.api('/me', function(res) {
            commit('setUserAccount',res.id)
            commit('setuserName',res.name)
            FB.api(
                `${res.id}/picture`,'GET',{'redirect':'false'},
                function(res) {
                    commit('setUserImg',res.data.url)
                }
            );
        });
      },
      getNotificationCount({commit,state}){
        return new Promise((resolve, reject) => {
            getNotificationCount({
                userName:state.userName
            }).then(res=>{
                if (res.status === 'success'){
                    commit('setNotificationCount',res.count)
                    resolve()
                }
            })
        });
    },
  //   checkout ({ commit, state }, products) {
  //     const savedCartItems = [...state.items]
  //     commit('setCheckoutStatus', null)
  //     // empty cart
  //     commit('setCartItems', { items: [] })
  //     shop.buyProducts(
  //       products,
  //       () => commit('setCheckoutStatus', 'successful'),
  //       () => {
  //         commit('setCheckoutStatus', 'failed')
  //         // rollback to the cart saved before sending the request
  //         commit('setCartItems', { items: savedCartItems })
  //       }
  //     )
  //   },
  
  //   addProductToCart ({ state, commit }, product) {
  //     commit('setCheckoutStatus', null)
  //     if (product.inventory > 0) {
  //       const cartItem = state.items.find(item => item.id === product.id)
  //       if (!cartItem) {
  //         commit('pushProductToCart', { id: product.id })
  //       } else {
  //         commit('incrementItemQuantity', cartItem)
  //       }
  //       // remove 1 item from stock
  //       commit('products/decrementProductInventory', { id: product.id }, { root: true })
  //     }
  //   }
  }
  
  // mutations
  const mutations = {
  //   pushProductToCart (state, { id }) {
  //     state.items.push({
  //       id,
  //       quantity: 1
  //     })
  //   },
  
  //   incrementItemQuantity (state, { id }) {
  //     const cartItem = state.items.find(item => item.id === id)
  //     cartItem.quantity++
  //   },
  
  //   setCartItems (state, { items }) {
  //     state.items = items
  //   },
  
  //   setCheckoutStatus (state, status) {
  //     state.checkoutStatus = status
  //   }
        setFbToken(state,value){
            state.fbStatus = value
        },
        setFbToken(state,value){
            localStorage.setItem('fbToken',value)
            state.fbToken = value
        },
        setAccessToken(state,value){
            if (localStorage.getItem('accessToken')){
                localStorage.getItem('accessToken')
            }
            localStorage.setItem('accessToken',value)
            state.accessToken = value
        },
        setUserAccount(state,value){
            localStorage.setItem('userAccount',value)
            state.userAccount = value
        },
        setUserEmail(state,value){
            localStorage.setItem('userEmail',value)
            state.userEmail = value
        },
        setuserName(state,value){
            localStorage.setItem('userName',value)
            state.userName = value
        },
        setUserImg(state,value){
            state.userImg = value
        },
        openLoginPopup(state){
            state.showLoginPopup = true
        },
        hideLoginPopup(state){
            state.showLoginPopup = false
        },
        openAddExchange(state){
            state.showAddExchange = true
        },
        hideAddExchange(state){
            state.showAddExchange = false
        },
        openAddTogether(state){
            state.showAddTogether = true
        },
        hideAddTogether(state){
            state.showAddTogether = false
        },
        openUserInfo(state){
            state.showUserInfo = true
        },
        hideUserInfo(state){
            state.showUserInfo = false
        },
        setNotificationCount (state, value) {
            state.notificationCount = value
        
          },
    }
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }